import {observable, action, runInAction} from 'mobx'
import {get, json,post} from '../../../../utils/ajax'
import {message} from "antd";
import {handleSearchAndPage, setStore, ValueObjToObj} from '../../../../utils/Utils'

class EPCPhotoManagerStore {

    @observable list
    @observable pagination
    @observable loading
    @observable history//查看历史模态框
    @observable modal
    @observable modalLoading
    @observable forms
    @observable carseries//车系列表数据
    @observable catalog
    @observable search
    @observable options
    @observable carSysId //保存下拉车系选中的ID
    @observable editCarSeriesCode //保存下拉车系选中的code
    @observable uploadLoading//上传图片的loading
    @observable batchUploadBtnIsClick //批量上传按钮是否能点击
    @observable modifyIsDisabled
    @observable editRecord
    @observable newGallery
    @observable carSeriesCodeValue
    @observable historyList//查看历史的历史图片
    @observable initFigure
    @observable sharingModal//共享图片模块
    @observable sharingRowData
    @observable sharingPicturesForm
    @observable modelStatus
    @observable editPhotoModal    //新增/修改模态框
    @observable editPhotoModalName  //新增/修改模态框名
    @observable photoHistoryModal  //图库历史记录模态框
    @observable SharingPicturesModal   //共享图片

    constructor() {
        this.list = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger:true,
            pageSize:20,
            showTotal:()=>{}
        }
        this.loading = false;
        this.history = false
        this.modal = false
        this.modalLoading = false
        this.forms = {}
        this.carseries = []
        this.catalog = []
        this.search = {
            carseriesCode:'',
            figureNo:''
        }
        this.options = []
        this.carSysId = ''
        this.uploadLoading = false
        this.batchUploadBtnIsClick = false
        this.modifyIsDisabled = false
        this.editCarSeriesCode = ''
        this.newGallery={
            carseriesCode:'',
            catalogId:'',
            figureNo:'',
            picture:'',
            explain:"",
        }
        this.editRecord=''
        this.carSeriesCodeValue=''
        this.historyList=[]
        this.initFigure=''
        this.sharingModal=false
        this.sharingRowData={}
        this.sharingPicturesForm={}
        this.modelStatus=false
        this.editPhotoModal = false
        this.editPhotoModalName = ''
        this.photoHistoryModal = false
        this.SharingPicturesModal = false
    }


    /**
     * 将表单时对象化，绑值给store。form
     */
    @action
    onFormsChange = (changedFields) => {
        this.forms={...this.forms,...changedFields}
    }
    /**
     * 每次更新search框时，回写数据
     * @param values search数据
     */
    @action
    onSearchFieldChange(values) {
        this.search = {...this.search,...values}
    }


    /**
     * 初始化车系
     */
    @action
    initCarseries = async () => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carseriesCatalog/queryCarList`)
        runInAction(() => {
            this.carseries = Array.isArray(res)?res:[]
        })
    }

    /**
     * 新闻列表 + 标题查询
     * 分页
     */
    @action
    initListPhoto = async (page) => {
        // if (!this.carSeriesCodeValue) {
        //     message.warning(`请选择车系！`)
        //     return
        // }
        this.loading = true
        if(this.search.carseriesCode===undefined){
            this.search.carseriesCode=''
        }
        let search = handleSearchAndPage(page, this.pagination, this.search)
        search[`search.carseriesCode`]= this.editCarSeriesCode
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogPhoto/queryListByPage`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.list = Array.isArray(res.content)? res.content:[]
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper:true,
                showSizeChanger:true,
                pageSize:res.size,
                showTotal:()=>`总共 ${res.totalElements} 条`
            }
            this.loading = false
            this.catalog = []
        })
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 重置表单
     * @returns {Promise<void>}
     */
    @action
    clearItem =() => {
        this.search = {
            carseriesCode:'',
            figureNo:''
        }
        this.carSysId=''
        this.editCarSeriesCode=''
        this.list = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger:true,
            pageSize:20,
            showTotal:()=>{}
        }
        this.initListPhoto()
    }
    /**
     * 删除
     */
    @action
    deletePhotoId = async (id) => {
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/epc/catalogPhoto/delete?id=${id}`)
        if (res && res.status === 0) {
            return
        }
        if (this.list.length === 1) {
            await this.initListPhoto(this.pagination.current - 1)
        } else {
            await this.initListPhoto(this.pagination.current)
        }
    }


    /**
     * 查看历史
     */
    @action showModal = async (id) => {
        this.historyList=[]
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogPhoto/getPhotoHistoryById/id/${id}`)
        if (res.length === 0) {
            message.warning('该车系没有历史图')
            return
        }
        runInAction(() => {
            this.historyList = Array.isArray(res)?res:[];
            this.history = true
        })
    }

    /**
     * 关闭模式
     */
    @action cancelHistory = () => {
        this.history = false
        this.modal = false
        this.modifyIsDisabled = false
        this.photoHistoryModal = false
    }

    /**
     * 图片上传
     */
    @action imageUpload = (info) => {
        runInAction(() => {
            this.loading = true
        })
        if (info.file.status === 'done') {
            info = info.file.response
            runInAction(() => {
                this.loading = false
            })
            return
        } else if (info.file.status === 'error') {
            runInAction(() => {
                this.loading = false
            })
            message.error(`${info.file.name} 上传失败`)
        }
    }

    /**
     * 批量上传（图片）压缩包
     */
    @action
    batchImgUpload = async (info) => {
        runInAction(() => {
            this.uploadLoading = true
            this.batchUploadBtnIsClick = true
        })
        if (info.file.status === 'done') {
            runInAction(() => {
                this.uploadLoading = false
                this.batchUploadBtnIsClick = false
            })
            message.success("上传成功")
            await this.initListPhoto(this.pagination.current)
            return
        } else if (info.file.status === 'error') {
            runInAction(() => {
                this.uploadLoading = false
                this.batchUploadBtnIsClick = false
            })
            if(info.file.response.code>1000){
                message.error(`文件上传失败（${info.file.response.msg}）`);
            }
            if(info.file.response.code>400&&info.file.response.code<1000){
                message.error(`文件上传失败`);
            }
        }
    }



    /**
     * 获取车系数据
     */
    @action
    initCatalog = async (value, type) => {
        let obj = this.carseries.find((item)=>item.carseriesName===value)
        let carserie = {...obj}
        this.newGallery.carseriesCode=carserie.carSeriesCode
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogSparePart/queryCatalogListByCarCode/carCode?carCode=${this.newGallery.carseriesCode}`)
        if (res && res.status === 0) {
            return
        }
        if (type === 1) {
            runInAction(() => {
                this.catalog = Array.isArray(res)?res:[]
            })
            return
        }
        // if (res.length === 0) {
        //     message.warning('该车系下没有目录，请正确选择车系')
        //     runInAction(() => {
        //         this.forms.figureNo = ''
        //     })
        // }
        runInAction(() => {
            // this.forms.figureNo = ''
            this.catalog = Array.isArray(res)?res:[]
        })
    }


    @action
    initCatalogId = async (value,label) => {
        this.newGallery.catalog3Name = label[0]
        this.initFigure=label.length>0&&label[0].split("【")[1]
        this.initFigure =this.initFigure.length>0?this.initFigure.slice(0,this.initFigure.length-1):''
        this.findChildren(this.catalog,this.initFigure)
    }

    @action
    findChildren=(arr,code)=>{
        for(let i in arr){
            if(!arr[i].children.length && arr[i].level ===3){
                if(arr[i].code===code){
                    this.newGallery.catalog3Id = arr[i].id

                }
            }else{
                this.findChildren(arr[i].children,code)
            }
        }
        return arr
    }



    /**
     * 新增图库 + 修改图库
     */
    @action
    savePhoto = async () => {
        this.modifyIsDisabled = false
        let data = {...ValueObjToObj(this.forms),
            // picture:`https:`+this.forms.picture.value.split(":")[this.forms.picture.value.split(":").length-1]
        }
        if (!this.editRecord) {
            data.catalog3Name=this.newGallery.catalog3Name;
            data.catalog3Id=this.newGallery.catalog3Id;
            data.carseriesCode=this.newGallery.carseriesCode;
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogPhoto/addCatalogPhoto`, data)
            if (res && res.status >= 400) {
                return
            } else {
                message.success('新增图库成功')
                runInAction(() => {
                    this.modal = false
                    this.forms = {}
                })
                await this.initListPhoto(this.pagination.current)
            }
        } else {
            data.id= this.editRecord.id
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogPhoto/updateById`, data)
            if (res && res.status >= 400) {
                message.error('修改失败')
                return
            } else {
                runInAction(() => {
                    this.modal = false
                    this.forms = {}
                })
                await this.initListPhoto(this.pagination.current)
            }
        }
    }

    /**
     * 初始化表单，可以不传参数，初始化全部为 null
     * @param record
     */
    @action
    initEdit = async (record) => {
        this.modal = true
        this.modalLoading = true
        this.modifyIsDisabled = true
        if(record){//修改
            this.loading = true
            this.editRecord = record
            runInAction(() => {
                this.loading = false
                this.forms = {
                    carseriesName:{value:record.carseriesName},
                    catalog3Name:{value:record.catalog3Name},
                    explain:{value:record.explain},
                    name: {value:record.name},
                    figureNo:{value:record.figureNo},
                    picture:{value:record.picture}
                }
            })
        }else {//新增
            this.editRecord=null
            this.forms = {
                carseriesName:{value:this.carSeriesCodeValue},
                catalog3Name:{value:''},
            }
        }
        runInAction(()=>{
            this.modalLoading = false
        })

    }



    /**
     * 取车系ID、车系code
     */
    @action
    getCarSysId = (value) => {
        runInAction(() => {
            let carserie = this.carseries.find((item)=>item.carseriesName===value)
            this.carSysId = carserie&&carserie.carseriesId;
            this.carSeriesCodeValue = value;
            this.editCarSeriesCode = carserie&&carserie.carSeriesCode;
        })
    }

    /**
     * 清空store的值
     */
    @action
    emptyHtmlValue = () => {
        this.carSysId = ""
        this.list = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger:true,
            pageSize:20,
            showTotal:()=>{}
        }
        this.carseries=[]
        this.catalog=[]
    }

    @action
    onSharingPicturesChange=(changedFields)=>{
        this.sharingPicturesForm={...this.sharingPicturesForm,...changedFields}
    }

    /**
     * 共享图片
     */
    @action
    sharingPicturesData=(record)=>{
        this.sharingModal=true
        this.sharingRowData=record
        this.SharingPicturesModal = true
    }

    @action
    saveSharingPicturesData=async ()=>{
        let one=this.catalog.find(item=>
            item.children.find(i=>i.children.find(j=>j.code===this.initFigure))
        )
        let twe=one.children.find(i=>i.code===this.initFigure.split('-')[0])
        let selectTreeData=twe.children.find(i=>i.code===this.initFigure)
        let selectcarData=this.carseries.find(item=>item.carseriesName===this.sharingPicturesForm.carseriesName.value)
        let search={}
        search[`search.id`]=this.sharingRowData.id
        search[`search.picture`]=this.sharingRowData.picture
        search[`search.carseriesCode`]=selectcarData.carSeriesCode
        search[`search.catalog3Id`]=selectTreeData.id
        search[`search.figureNo`]=this.initFigure

        await post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogPhoto/shareImg`,search)
        runInAction(()=>{
            this.sharingModal=false
            this.sharingPicturesForm={}
            this.initListPhoto(this.pagination.current)
        })
    }

    /**
     * 删除借用关系
     * @param id
     * @returns {Promise<void>}
     */
    @action
    deleteRowBorrow=async (id)=>{
        const res=await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogPhoto/photosRelationship/delete/${id}`)
        if(res.status){
            message.success(`删除成功！`)
        }
    }

    /**
     * 校验三级目录是否存在
     * @param value
     * @returns {Promise<{msg: string, status: number}|{msg: string, status: number}|undefined>}
     */
    @action
    catalog3NameData=async(value)=>{
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/catalogPhoto/verify/${this.editCarSeriesCode}/${this.newGallery.catalog3Id}`)
        if (!res){
            message.warning('该数据已存在')
        }else {
            return res
        }
    }
}

export default new EPCPhotoManagerStore()



// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/EPC/EPCPhotoManager/store.js